import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/core/services/data.service';
import { UtilsService } from 'src/app/core/services/utils.service';

import { AppStateInterface } from 'src/app/appState.interface';
import { Store, select } from '@ngrx/store';

import { selectedCustomerSelector } from 'src/app/core/store/selectors';

@Component({
  selector: 'app-cutomers-tree-ref-20',
  templateUrl: './cutomers-tree-ref-20.component.html',
  styleUrls: ['./cutomers-tree-ref-20.component.scss']
})
export class CutomersTreeRef20Component implements OnInit, OnChanges, OnDestroy {

  private destroy$ = new Subject<void>();

  selectedCustomerFromStore$: any;
  public customers: any;
  @Output() customerSelected = new EventEmitter<any>();
  @Input() refreshCustomers: boolean;
  @Input() selectedCustomer: any;

  treeElementsList: any[] = [];
  @Input() isForFilter: boolean = false;
  stylesheetString: string = 'aft';

  // PrimeNG Tree properties
  treeNodes: TreeNode[] = [];
  selectedNode: TreeNode | null = null;
  filterText: string = '';
  private originalNodes: TreeNode[] = [];

  @Input()
  get listIn(): any {
    return this._listIn;
  }
  set listIn(value: any) {
    this._listIn = value;
    // IMPORTANT: this prevents the error on is not extensible
    this.customers = JSON.parse(JSON.stringify(value));
    this.buildTreeNodes();
  }
  private _listIn: any;

  userInfo = this.dataService.getCurrentUserInfo();

  constructor(
    private utilsService: UtilsService,
    private dataService: DataService,
    private store: Store<AppStateInterface>
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit(): void {
    this.stylesheetString = this.utilsService.getStylesheetString();

    // Subscribe to store only to track the currently selected customer (for highlight)
    this.store.pipe(
      select(selectedCustomerSelector),
      takeUntil(this.destroy$)
    ).subscribe((res) => {
      this.selectedCustomerFromStore$ = res ? JSON.parse(JSON.stringify(res)) : null;
    });
  }

  resetSearchInput(): void {
    this.filterText = '';
    this.treeNodes = JSON.parse(JSON.stringify(this.originalNodes));
  }

  private buildTreeNodes(): void {
    if (!this.customers || this.customers.length === 0) {
      this.treeNodes = [];
      this.originalNodes = [];
      return;
    }

    const nodeMap = new Map<string, TreeNode>();

    // Create all nodes first
    this.customers.forEach((customer: any) => {
      const node: TreeNode = {
        key: customer.uid,
        label: customer.nameWithChildren || customer.name,
        data: customer,
        children: [],
        expanded: false
      };
      nodeMap.set(customer.uid, node);
    });

    // Build tree structure
    const rootNodes: TreeNode[] = [];
    this.customers.forEach((customer: any) => {
      const node = nodeMap.get(customer.uid);
      if (node) {
        if (customer.uidParent === null || customer.uidParent === undefined) {
          rootNodes.push(node);
        } else {
          const parentNode = nodeMap.get(customer.uidParent);
          if (parentNode) {
            parentNode.children = parentNode.children || [];
            parentNode.children.push(node);
          } else {
            rootNodes.push(node);
          }
        }
      }
    });

    // Expand only root nodes (level 1)
    rootNodes.forEach(node => { node.expanded = true; });

    this.treeNodes = rootNodes;
    this.originalNodes = JSON.parse(JSON.stringify(rootNodes));
  }

  private expandToNode(uid: string): void {
    const expandParents = (nodes: TreeNode[], targetUid: string): boolean => {
      for (const node of nodes) {
        if (node.key === targetUid) {
          this.selectedNode = node;
          return true;
        }
        if (node.children && node.children.length > 0) {
          if (expandParents(node.children, targetUid)) {
            node.expanded = true;
            return true;
          }
        }
      }
      return false;
    };

    expandParents(this.treeNodes, uid);
  }

  filterNodes(): void {
    if (!this.filterText || this.filterText.trim() === '') {
      this.treeNodes = JSON.parse(JSON.stringify(this.originalNodes));
      return;
    }

    const filterText = this.filterText.toLowerCase();
    this.treeNodes = this.filterTreeNodes(JSON.parse(JSON.stringify(this.originalNodes)), filterText);
  }

  private filterTreeNodes(nodes: TreeNode[], filterText: string): TreeNode[] {
    const result: TreeNode[] = [];

    for (const node of nodes) {
      const labelMatches = node.label?.toLowerCase().includes(filterText);
      let filteredChildren: TreeNode[] = [];

      if (node.children && node.children.length > 0) {
        filteredChildren = this.filterTreeNodes(node.children, filterText);
      }

      if (labelMatches || filteredChildren.length > 0) {
        const newNode = { ...node };
        newNode.children = filteredChildren;
        newNode.expanded = filteredChildren.length > 0;
        result.push(newNode);
      }
    }

    return result;
  }

  onNodeSelect(event: any): void {
    this.isForFilter = true;
    const nodeData = event.node.data;
    this.customerSelected.emit(nodeData);
  }

  onNodeExpandCollapse(_event: any): void {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
